angular
	.module 'App.Value'
	.value 'snakeCaseToCamelCase', (string, lowercaseFirst = true) ->

		convertedString = string
			.split '_'
			.map (substr) => substr.charAt(0).toUpperCase() + substr.slice(1)
			.join ''

		if (lowercaseFirst)
			return convertedString.charAt(0).toLowerCase() + convertedString.slice(1);

		return convertedString
